var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRejectionCodes } from "./hook/rejectionCodes.hook";
import { RejectionCodesView } from "./view/rejectionCodes.view";
export var RejectionCodes = function () {
    var p = useRejectionCodes();
    return _jsx(RejectionCodesView, __assign({}, p));
};
export default RejectionCodes;
